import * as React from 'react';
import { Form, Spinner } from 'react-bootstrap';
import { useFetcher } from 'react-router-dom';

import { PatcherContext } from '@/helper/context';
import { formatErrors } from '@/helper/utility';

interface Properties {
  id: number;
  values: Record<string, any>;
  url: string;
  disabled: boolean;
  children: React.ReactNode;
}

export function Patcher({ id, values, url, disabled, children }: Properties) {
  const fetcher = useFetcher();
  const [isLoading, setIsLoading] = React.useState(false);
  const [errors, setErrors] = React.useState<any>({});
  React.useEffect(() => {
    if (fetcher.state == 'loading' || fetcher.state == 'submitting') {
      setIsLoading(true);
    } else {
      if (fetcher.data?.status == 200) {
        setErrors({});
      } else {
        if (typeof fetcher.data === 'object') {
          setErrors(formatErrors(fetcher.data));
        }
      }
      setIsLoading(false);
    }
  }, [fetcher]);

  // optimistic ui
  if (fetcher.formData) {
    for (const key in values) {
      // eslint-disable-next-line security/detect-object-injection
      values[key] = fetcher.formData.get(key);
    }
  }

  function onChange(event: React.ChangeEvent<HTMLInputElement>) {
    let newValues;
    if (event.target.type == 'checkbox') {
      newValues = { ...values, [event.target.name]: event.target.checked };
    } else if (event.target.type == 'select-one' || event.target.type == 'number') {
      newValues = { ...values, [event.target.name]: event.target.value };
    }

    fetcher.submit(newValues, {
      method: 'patch',
      action: url + '/' + id
    });
  }

  return (
    <PatcherContext.Provider value={{ onChange, values, errors, disabled }}>
      {isLoading && <Spinner animation='border' size='sm' style={{ float: 'right', marginTop: '-35px' }} />}
      <Form noValidate>{children}</Form>
    </PatcherContext.Provider>
  );
}
